/**
 * Check if two links are adjacent in the DOM (only whitespace/text between them)
 */
export function isAdjacentInDOM(link1, link2) {
  if (!link1 || !link2) return false;

  let node = link1.nextSibling;

  while (node && node !== link2) {
    // Allow text nodes with only whitespace
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.textContent.trim() !== '') {
        return false; // Non-whitespace text separates them
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      return false; // Element separates them
    }

    node = node.nextSibling;
  }

  return node === link2;
}

/**
 * Group consecutive links that are adjacent in the DOM
 */
export function groupAdjacentLinks(links) {
  if (!links || links.length === 0) return [];

  const groups = [];
  let currentGroup = [links[0]];

  for (let i = 1; i < links.length; i++) {
    if (isAdjacentInDOM(links[i - 1], links[i])) {
      currentGroup.push(links[i]);
    } else {
      groups.push(currentGroup);
      currentGroup = [links[i]];
    }
  }

  // Don't forget last group
  if (currentGroup.length > 0) {
    groups.push(currentGroup);
  }

  return groups;
}